export class Info {
  status: string;
  pin_number: string;
  transaction_id: string;
  reg_date: Date;
  end_date: Date;
  start_worker_id: string;
  start_worker_type: string;
  end_worker_id: string;
  end_worker_type: string;
  approve_date: string;
  approved_rate: number;
  transaction_reason: string = '';
  sourceOfIncome: string = '';
  relationshipToBeneficiary: string = '';
  timeStamp: string;
  agent_name: string;
  transaction_remark: string;
  deposit_account: string;

  static CloneForCreateTransaction(info: Info) {
    const clone = new Info();
    clone.start_worker_id = info.start_worker_id;
    clone.start_worker_type = info.start_worker_type;
    clone.transaction_reason = info.transaction_reason;
    clone.sourceOfIncome = info.sourceOfIncome;
    clone.relationshipToBeneficiary = info.relationshipToBeneficiary;
    clone.transaction_remark = info.transaction_remark;
    clone.timeStamp = info.timeStamp;
    return clone;
  }
}



// WEBPACK FOOTER //
// ./src/app/model/shared/transaction/info.ts